const tracer = typeof window === 'undefined' ? require('dd-trace').init() : undefined;
module.exports = {
  tracer
};